import { useEffect } from "react";
import { useLocation } from "react-router";

import { openShareMeetingModal } from "~/meetingRecorder/ShareMeetingModal";

/**
 * Hook that detects the `openShareModal` URL parameter and automatically triggers the share modal.
 * After triggering, it removes the parameter from the URL.
 *
 * @param noteId - The ID of the note to share
 */
export function useShareModalFromUrl(noteId: string | null) {
	const location = useLocation();

	useEffect(() => {
		if (!noteId) return; // Only run if we have a note ID

		const searchParams = new URLSearchParams(location.search);
		const openShareModal = searchParams.get("openShareModal");

		if (openShareModal === "true") {
			openShareMeetingModal(noteId, "Share");
		}
	}, [location.search, noteId]);
}
